import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { initializeMsal } from './auth/msalInstance';
import './styles/main.scss';

const rootElement = document.getElementById('app');

if (!rootElement) {
  throw new Error('Das Wurzelelement "#app" wurde nicht gefunden.');
}

/**
 * MSAL muss vor dem ersten Render initialisiert sein und eine offene Weiterleitung
 * abgeschlossen haben — Pendant zum MSAL-Start in Program.cs des Altclients.
 */
async function startApplication(container: HTMLElement): Promise<void> {
  await initializeMsal();

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void startApplication(rootElement);
